
import { AppConst } from '../services/CombeniaService/consts/AppConsts';

export const env: Environment = {
  
  baseUrl:"https://virtualshowroom.keringeyewear.com//combenia/",
  serviceUrl: "https://virtualshowroom.keringeyewear.com/kevsapi",
  authUrl:"https://virtualshowroom.keringeyewear.com",
  imageUrl: "https://virtualshowroom.keringeyewear.com/kevsapi/resource/filename/",
  tenant: "kevs",
  hash: "hash",
  channel:"Quality",
  pendingfiles: "pendingfiles",
  workingDirectory: "workingDirectory",
  conserveDataDays: "4",
  pushId: "",
  loginMethod: AppConst.LOGIN_METHOD.ONLINE,
  dbName: 'combenia',
  zipUrl: 'http://webportal2.getgeneration.com/logstore/glomp.app'
}


interface Environment {
  baseUrl: string;
  serviceUrl:string;
  authUrl:string;
  imageUrl: string;
  tenant: string;
  hash: string;
  channel:string;
  pendingfiles: string;
  workingDirectory: string;
  conserveDataDays: string;
  pushId: string;
  token?: string;
  loginMethod: string;
  dbName: string;
  zipUrl: string;
}

